export function initPersonFilter(): void {
    const clearButtons = document.querySelectorAll<HTMLButtonElement>('[data-person-filter-clear]');

    clearButtons.forEach((button) => {
        const input = button.closest('.person-filter__search-wrapper')?.querySelector<HTMLInputElement>('input');
        const form = button.closest('form');
        if (!input || !form) return;

        const toggleVisibility = () => {
            button.classList.toggle('is-visible', input.value.length > 0);
        };

        input.addEventListener('input', toggleVisibility);
        button.addEventListener('click', () => {
            input.value = '';

            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit();
            } else {
                form.submit();
            }
        });
    });
}
